/*
 * @description:
 * @author: Jason Wong
 * @since: 2022-11-15 11:50:22
 */
import { ShortCutKeyDescritpion } from "../index";
const ShortcutBase = {
  props: {
    shortcutKey: String,
  },
  data() {
    return {
      shortcutDescription: null,
    };
  },
  inject: ["keySubscriber"],
  computed: {
    shortcutTitle() {
      return !!this.shortcutDescription ? this.shortcutDescription.label : null;
    },
  },
  created() {
    console.log("#-# shortcut created", this.shortcutKey, this.keySubscriber, this.shortcutHandler);
    if (!!this.shortcutKey && !!this.keySubscriber && !!this.shortcutHandler) {
      this.shortcutDescription = ShortCutKeyDescritpion.parse(this.shortcutKey);
      if (this.shortcutMoment) {
        this.shortcutDescription.triggerMoment = this.shortcutMoment;
      }
      this.keySubscriber.subscribe(this.shortcutDescription, this.shortcutHandler);
    }
  },
};

export default ShortcutBase;
